module.exports = __webpack_public_path__ + "static/media/sake.99cd6dc1.jpeg";